import { render, staticRenderFns } from "./CalendarEventTimePlaceholder.vue?vue&type=template&id=729e7bed&scoped=true"
import script from "./CalendarEventTimePlaceholder.vue?vue&type=script&lang=js"
export * from "./CalendarEventTimePlaceholder.vue?vue&type=script&lang=js"
import style0 from "./CalendarEventTimePlaceholder.vue?vue&type=style&index=0&id=729e7bed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729e7bed",
  null
  
)

export default component.exports